import { ModalCollectionSelectInterface } from '@/store/ModalCollectionSelectStore'
import { modalCollectionSelectStore } from '@/utils/store-accessor'

export class ModalCollectionSelectService {
  public open(params?: ModalCollectionSelectInterface) {
    modalCollectionSelectStore.open(params)
  }
}
